// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3530":"23df5874","9538":"aebccccd"}[chunkId] + ".chunk.css";
};